import { BrandKitRootAgent } from 'js/src/agent/root-agents/BrandKitRootAgent';
import { ChatRootAgent } from 'js/src/agent/root-agents/ChatRootAgent';
import { ImproveMediaRootAgent } from 'js/src/agent/root-agents/ImproveMediaRootAgent';
import { type RootAgent, type RootAgentConfig } from 'js/src/agent/root-agents/RootAgent';
import { SketchRootAgent } from 'js/src/agent/root-agents/SketchRootAgent';
import { ToolboxRootAgent } from 'js/src/agent/root-agents/ToolboxRootAgent';

export interface AgentOption {
    value: string;
    label: string;
    agentClass: new (config: RootAgentConfig) => RootAgent;
}

export const AVAILABLE_AGENTS: AgentOption[] = [
    {
        value: 'default',
        label: 'Default Agent',
        agentClass: ChatRootAgent,
    },
    {
        value: 'improve-media',
        label: 'Improve Media Agent',
        agentClass: ImproveMediaRootAgent,
    },
    {
        value: 'sketch',
        label: 'Sketch Agent',
        agentClass: SketchRootAgent,
    },
    {
        value: 'brand-kit',
        label: 'Brand Kit Extractor',
        agentClass: BrandKitRootAgent,
    },
    {
        value: 'toolbox',
        label: 'Toolbox',
        agentClass: ToolboxRootAgent,
    },
];
